<template>
    <div class="keku-header">
        <div class="header-tabs">
            <div class="tabs" @mousemove="getsg()" @mouseleave="getgss()" @click="getwx()">
                <img src="@/assets/image/kh.png" alt="" style="margin-top:48px;width:71px" v-if="ind ==0"> 
                <img src="@/assets/image/xz1.png" alt="" style="margin-top:48px;width:71px" v-else-if="ind ==1">
                <p style="margin-top:33px"><span style="font-size: 24px;">Windows客户端</span></p>
            </div>
            <div class="tabs" @mousemove="getsg1()" @mouseleave="getgss1()" @click="getax()">
                <img src="@/assets/image/mac.png" alt="" style="margin-top:48px;width:71px" v-if="ind1 ==0">
                <img src="@/assets/image/xz1.png" alt="" style="margin-top:48px;width:71px" v-else-if="ind1 ==1">
                <p style="margin-top:33px"><span style="font-size: 24px;">Mac客户端</span></p>
            </div>
            <div class="tabs" @mousemove="getsg2()" @mouseleave="getgss2()"  @click="getmx()">
                <img src="@/assets/image/az.png" alt="" style="margin-top:48px;width:71px" v-if="ind2 ==0">
                <img src="@/assets/image/xz1.png" alt="" style="margin-top:48px;width:71px" v-else-if="ind2 ==1">
                <p style="margin-top:33px"><span style="font-size: 24px;">Android客户端</span></p>
            </div>
            <div class="tabs" style="margin-top:25px" @mousemove="getsg3()" @mouseleave="getgss3()" @click="getlx()">
                <img src="@/assets/image/lx.png" alt="" style="margin-top:48px;width:71px" v-if="ind3 ==0">
                <img src="@/assets/image/xz1.png" alt="" style="margin-top:48px;width:71px" v-else-if="ind3 ==1">
                <p style="margin-top:33px"><span style="font-size: 24px;">Linux-X86客户端</span></p>
            </div>
            <div class="tabs"  style="margin-top:25px" @mousemove="getsg4()" @mouseleave="getgss4()" @click="getlsx()">
                <img src="@/assets/image/lx.png" alt="" style="margin-top:48px;width:71px" v-if="ind4 ==0">
                <img src="@/assets/image/xz1.png" alt="" style="margin-top:48px;width:71px" v-else-if="ind4 ==1">
                <p style="margin-top:33px"><span style="font-size: 24px;">Linux-ARM64客户端</span></p>
            </div>
            <div class="tabs"  style="margin-top:25px" @mousemove="getsg5()" @mouseleave="getgss5()" @click="getliosx()">
                <img src="@/assets/image/mac.png" alt="" style="margin-top:48px;width:71px"  v-if="ind5 ==0">
                <img src="@/assets/image/xz1.png" alt="" style="margin-top:48px;width:71px" v-else-if="ind5 ==1">
                <p style="margin-top:33px"><span style="font-size: 24px;">IOS客户端</span></p>
            </div>
        </div>
        <div class="kehu">
            <span style="font-size: 16px;color: #5B5B5B;text-align:center;display:inline-block;width:100%;margin-top:60px">客户端使用引导</span>
            <div style="display: flex;justify-content: space-around;">
              <div class="ktabs">
                <div style="text-align:center;margin-top:40px">
                    <img src="@/assets/image/yi.png" alt="" style="vertical-align: middle;">
                    <span style="font-size:16px;margin-left:10px;vertical-align: middle;">安装客户端</span>
                </div>
                <div style="text-align:center;margin-top:53px">
                    <img src="@/assets/image/hs.png" alt="" style="width:127px;height:202px">
                </div>
                <div style="margin-left:36px;margin-top:38px">
                     <p style="width: 325px;height: 35px;font-size: 14px;color: #5B5B5B;"><span style="width: 5px;height: 5px;background: #318AFD;border-radius: 50%;display:inline-block;vertical-align: middle;margin-top:-2px;margin-left:-8px;margin-right:8px"></span>PC端下载客户端安装，移动端扫描二维码安装APP</p>
                     <p style="width: 325px;height: 35px;font-size: 14px;color: #5B5B5B;"><span style="width: 5px;height: 5px;background: #318AFD;border-radius: 50%;display:inline-block;vertical-align: middle;margin-top:-2px;margin-left:-8px;margin-right:8px"></span>安装后启动客户端，配置本地部署系统地址 </p>
                </div>
            </div>
            <div class="ktabs">
                <div style="text-align:center;margin-top:40px">
                    <img src="@/assets/image/er.png" alt="" style="vertical-align: middle;">
                    <span style="font-size:16px;margin-left:10px;vertical-align: middle;">安排和加入会议</span>
                </div>
                <div style="text-align:center;margin-top:53px">
                    <img src="@/assets/image/hs1.png" alt="" style="width:134px;height:225px">
                </div>
                <div style="margin-left:36px;margin-top:13px">
                     <p style="width: 325px;height: 35px;font-size: 14px;color: #5B5B5B;"><span style="width: 5px;height: 5px;background: #318AFD;border-radius: 50%;display:inline-block;vertical-align: middle;margin-top:-2px;margin-left:-8px;margin-right:8px"></span>输入用户名和密码登录系统，可以通过会议列表或会议号加入会议</p>
                     <p style="width: 325px;height: 35px;font-size: 14px;color: #5B5B5B;margin-top:15px"><span style="width: 5px;height: 5px;background: #318AFD;border-radius: 50%;display:inline-block;vertical-align: middle;margin-top:-2px;margin-left:-8px;margin-right:8px"></span>发起即时会议或预约安排一个会议</p>
                </div>
            </div>
            <div class="ktabs">
                <div style="text-align:center;margin-top:40px">
                    <img src="@/assets/image/san.png" alt="" style="vertical-align: middle;">
                    <span style="font-size:16px;margin-left:10px;vertical-align: middle;">开始会议</span>
                </div>
                <div style="text-align:center;margin-top:53px">
                    <img src="@/assets/image/hs2.png" alt="">
                </div>
                <div style="margin-left:36px;margin-top:33px">
                     <p style="width: 325px;height: 35px;font-size: 14px;color: #5B5B5B;"><span style="width: 5px;height: 5px;background: #318AFD;border-radius: 50%;display:inline-block;vertical-align: middle;margin-top:-2px;margin-left:-8px;margin-right:8px"></span>进入会议，打开或关闭自己的音视频，进行音视频</p>
                     <p style="width: 325px;height: 35px;font-size: 14px;color: #5B5B5B;"><span style="width: 5px;height: 5px;background: #318AFD;border-radius: 50%;display:inline-block;vertical-align: middle;margin-top:-2px;margin-left:-8px;margin-right:8px"></span>交流主持人可以通过参加者列表进行会控管理</p>
                </div>
            </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    data(){
        return{
            ind:0,
            ind1:0,
            ind2:0,
            ind3:0,
            ind4:0,
            ind5:0,
        }
    },
    methods:{
        getwx(){
            const a = document.createElement('a')
            document.body.appendChild(a)
            a.style = 'display: none'
            a.href = 'http://www.hongshanmeeting.com/download/HongshanMeeting_EasyConf.zip'
            a.click()
            window.URL.revokeObjectURL(url)
        },
        getax(){
              const ele = document.createElement('a');

              ele.setAttribute('href','https://apps.apple.com/cn/app/%E7%BA%A2%E6%9D%89%E4%BC%9A%E8%AE%AE/id6447675999?mt=12'); //设置下载文件的url地址

              ele.setAttribute('download' , 'download');//用于设置下载文件的文件名

              ele.click();
        },
        getmx(){
             window.location.href ="http://www.hongshanmeeting.com/download/HongshanMeeting_AndroidApp.png"
        },
        getlx(){
                const a = document.createElement('a')
                document.body.appendChild(a)
                a.style = 'display: none'
                a.href = 'http://www.hongshanmeeting.com/download/HongshanMeeting_Linux-X86_64.zip'
                a.click()
                window.URL.revokeObjectURL(url)
        },
        getlsx(){
                const a = document.createElement('a')
                document.body.appendChild(a)
                a.style = 'display: none'
                a.href = 'http://www.hongshanmeeting.com/download/HongshanMeeting_Linux-ARM64.zip'
                a.click()
                window.URL.revokeObjectURL(url)
        },
        getliosx(){
                const a = document.createElement('a')
                document.body.appendChild(a)
                a.style = 'display: none'
                a.href = 'https://apps.apple.com/cn/app/%E7%BA%A2%E6%9D%89%E4%BC%9A%E8%AE%AE-%E5%A4%9A%E4%BA%BA%E5%AE%9E%E6%97%B6%E8%A7%86%E9%A2%91%E4%BC%9A%E8%AE%AE%E8%BD%AF%E4%BB%B6/id6449668530'
                a.click()
                window.URL.revokeObjectURL(url)
        },
         getsg(){
             this.ind = 1
        },
        getgss(){
                this.ind = 0
        },
        getsg1(){
                this.ind1 = 1
        },
        getgss1(){
                this.ind1 = 0
        },
        getsg2(){
                this.ind2 = 1
        },
        getgss2(){
                this.ind2 = 0
        },
        getsg3(){
                this.ind3 = 1
        },
        getgss3(){
                this.ind3 = 0
        },
    getsg4(){
                this.ind4 = 1
        },
        getgss4(){
                this.ind4 = 0
        },
        getsg5(){
                this.ind5 = 1
        },
        getgss5(){
                this.ind5 = 0
        }
    }
}
</script>
<style lang="scss">
    .keku-header{
        width: 1240px;
        margin: 0 auto;
        position: relative;
        top:260px;
        .header-tabs{
            display: flex;
            flex-wrap: wrap;
            justify-content: space-around;
            .tabs{
                width: 386px;
                height: 227px;
                background: #FFFFFF;
                border: 1px solid #F1F1F1;
                border-radius: 10px;
                text-align: center;
                cursor: pointer;
            }
        }
        .kehu{
            .ktabs{
                width: 386px;
                height: 447px;
                background: #FFFFFF;
                border: 1px solid #CAD9FF;
                border-radius: 10px;
                margin-top: 20px;
            }
        }
    }
</style>